"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("../../openapi");
let QueryParameterError = class QueryParameterError extends Error {
    names;
    errorCode;
    constructor(errorCode, paramNames) {
        const message = `Invalid Parameter ${paramNames} ErrorCode: ${errorCode}`;
        super(message);
        this.names = paramNames;
        this.errorCode = errorCode;
    }
};
__decorate([
    (0, openapi_1.Schema)({
        type: 'array',
        items: { type: 'string' },
        description: 'Array containing the string names of the parameters that triggered the error throw',
    })
], QueryParameterError.prototype, "names", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number', description: 'The number of the QpErrorCode' })
], QueryParameterError.prototype, "errorCode", void 0);
QueryParameterError = __decorate([
    (0, openapi_1.ClassSchema)({
        description: 'Error thrown by function ValidatePathParameter on class EventValidator',
    })
], QueryParameterError);
exports.default = QueryParameterError;
